<div class="shop-price-popup-container">
    <div class="popup-header">
        <div class="title">Shop Prices - {{itemName}}</div>
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="search-bar">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search Shop Name</mat-label>
            <input matInput [(ngModel)]="searchText" (keyup)="onSearch()" placeholder="Type to search...">
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
            <!-- Serial Number Column -->
            <ng-container matColumnDef="serialNo">
                <th mat-header-cell *matHeaderCellDef> S/N </th>
                <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
            </ng-container>

            <!-- Shop Name Column -->
            <ng-container matColumnDef="shopName">
                <th mat-header-cell *matHeaderCellDef> Shop Name </th>
                <td mat-cell *matCellDef="let element"> {{element.shop_name}} </td>
            </ng-container>


            <!-- Price Column -->
            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Price </th>
                <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.price | currency:'USD':'symbol':'1.2-2'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="3">No data matching the filter "{{searchText}}"</td>
            </tr>
        </table>
    </div>
</div>
